module.exports = __webpack_public_path__ + "img/cover-scrum-board.747a0b9d.png";